enum NavigationScope {
    NotSet,
    SysAdmin,
    Agency,
    Company
}

export default NavigationScope